module.exports = __webpack_public_path__ + "img/borderCornerRightWhite.2c82e000.svg";